import { render, staticRenderFns } from "./area-fields-db.component.vue?vue&type=template&id=56a859cb"
import script from "./area-fields-db.component.ts?vue&type=script&lang=ts&external"
export * from "./area-fields-db.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports